import {
    getAdPlatformIds,
    getGtmUserMatchingPayload,
    AdExternalIds,
} from "@smile2impress/attraction-utils";

import { getAppMode } from "utils/getAppMode";

import { GTMEvents } from "./events";
import { ExperimentData } from "./types";

export const sendGTMEvent = (
    eventName: string,
    payload?: { [key: string]: string }
) => {
    const { isDevMode } = getAppMode();

    if (isDevMode) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...getGtmUserMatchingPayload(),
        ...getAdPlatformIds(),
        ...payload,
    });
};

export const sendAllGoogleAnalitic = (
    { experimentGroupId }: ExperimentData,
    externalIds?: AdExternalIds
) => {
    const { isDevMode } = getAppMode();

    if (isDevMode) return;

    const gtmFormSubmitPayload = {
        ...(experimentGroupId && {
            experimentalGroupId: String(experimentGroupId),
        }),
        ...(externalIds?.luEventId && { event_id: externalIds.luEventId }),
    };

    sendGTMEvent(GTMEvents.FORM_SUBMIT_GTM_EVENT, gtmFormSubmitPayload);
};
